import { render } from "./ZhengshuGongshiJIChaxunView.vue?vue&type=template&id=880f4b1e&scoped=true"
import script from "./ZhengshuGongshiJIChaxunView.vue?vue&type=script&lang=js"
export * from "./ZhengshuGongshiJIChaxunView.vue?vue&type=script&lang=js"

import "./ZhengshuGongshiJIChaxunView.vue?vue&type=style&index=0&id=880f4b1e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880f4b1e"]])

export default __exports__